function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgMenuClipBoard = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "3.022 3.962 18.795 16.141",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
  d: "M 18.142 5.047 L 16.963 5.047 L 16.963 4.808 C 16.963 4.331 16.575 3.949 16.106 3.949 L 8.814 3.949 C 8.337 3.949 7.957 4.337 7.957 4.808 L 7.957 5.047 L 6.778 5.047 C 6.247 5.047 5.818 5.477 5.818 6.001 L 5.818 19.119 C 5.818 19.649 6.247 20.079 6.778 20.079 L 18.142 20.079 C 18.673 20.079 19.101 19.649 19.101 19.119 L 19.101 6.001 C 19.101 5.477 18.673 5.047 18.142 5.047 Z M 8.957 4.944 L 15.963 4.944 L 15.963 6.118 L 8.957 6.118 L 8.957 4.944 Z M 18.101 19.078 L 6.819 19.078 L 6.819 6.05 L 7.957 6.05 L 7.957 6.254 C 7.957 6.732 8.344 7.114 8.814 7.114 L 16.106 7.114 C 16.583 7.114 16.963 6.724 16.963 6.254 L 16.963 6.05 L 18.101 6.05 L 18.101 19.078 Z",
  fill: "#646464",
  style: {}
}), /*#__PURE__*/React.createElement("path", {
  d: "M 9.522 9.828 L 8.453 9.828 C 8.174 9.828 7.949 10.054 7.949 10.333 C 7.949 10.613 8.174 10.838 8.453 10.838 L 9.522 10.838 C 9.801 10.838 10.026 10.613 10.026 10.333 C 10.026 10.054 9.801 9.828 9.522 9.828 Z",
  fill: "#646464",
  style: {}
}), /*#__PURE__*/React.createElement("path", {
  d: "M 9.522 12.631 L 8.453 12.631 C 8.174 12.631 7.949 12.856 7.949 13.136 C 7.949 13.416 8.174 13.641 8.453 13.641 L 9.522 13.641 C 9.801 13.641 10.026 13.416 10.026 13.136 C 10.026 12.856 9.801 12.631 9.522 12.631 Z",
  fill: "#646464",
  style: {}
}), /*#__PURE__*/React.createElement("path", {
  d: "M 16.468 9.828 L 11.927 9.828 C 11.647 9.828 11.423 10.054 11.423 10.333 C 11.423 10.613 11.647 10.838 11.927 10.838 L 16.468 10.838 C 16.747 10.838 16.971 10.613 16.971 10.333 C 16.964 10.054 16.74 9.828 16.468 9.828 Z",
  fill: "#646464",
  style: {}
}), /*#__PURE__*/React.createElement("path", {
  d: "M 16.468 12.631 L 11.927 12.631 C 11.647 12.631 11.423 12.856 11.423 13.136 C 11.423 13.416 11.647 13.641 11.927 13.641 L 16.468 13.641 C 16.747 13.641 16.971 13.416 16.971 13.136 C 16.971 12.856 16.74 12.631 16.468 12.631 Z",
  fill: "#646464",
  style: {}
}));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMenuClipBoard, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/menu-clip-board.532e030d.svg";
export { ForwardRef as ReactComponent };